import {Option} from 'platform/components';

import {isEmpty, isNil} from 'ramda';

import {BaseServiceOrderVariant} from '@dms/api/warehouse';

import {Nullish} from 'shared/web';

export const getOptionsFromServiceOrderVariants = (
  serviceOrderVariants: BaseServiceOrderVariant[] | Nullish
): Option[] => {
  if (isNil(serviceOrderVariants) || isEmpty(serviceOrderVariants)) {
    return [];
  }

  return serviceOrderVariants.map((serviceOrderVariant) => ({
    label: serviceOrderVariant?.name,
    value: serviceOrderVariant?.id,
  }));
};
